import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getStudentQuizHistory = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/would-you-rather/wyr-quizzes/results/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getActivities = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/would-you-rather/activities/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getHollandCodes = ({ version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/would-you-rather/holland-codes/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateWYRQuiz = ({ version = 'v1', quizUuid, payload } = {}) =>
  client
    .request({
      url: `${version}/would-you-rather/wyr-quizzes/${quizUuid}`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getWYRProgramConfig = ({ version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/cp-programs/wyr-program-config/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const favoriteProgram = ({ version = 'v1', payload } = {}) =>
  client
    .request({
      url: `${version}/cp-programs/favorite/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);
